import { create } from "zustand";
import { BrandRFMProfile } from "../models/brandRFMProfile";

interface BrandRFMProfileStore {
  brandRFMProfileId: string | null;
  brandRFMProfile: BrandRFMProfile[];
  selectedBrandRFMProfile: BrandRFMProfile | null;
  setBrandRFMProfileId: (id: string | null) => void;
  setBrandRFMProfile: (brandRFMSetting: BrandRFMProfile[]) => void;
  setSelectedBrandRFMProfile: (brandRFMSetting: BrandRFMProfile) => void;
}

export const useBrandRFMProfileStore = create<BrandRFMProfileStore>((set) => ({
  brandRFMProfileId: null,
  brandRFMProfile: [],
  selectedBrandRFMProfile: null,
  setSelectedBrandRFMProfile: (profile: BrandRFMProfile) =>
    set({ selectedBrandRFMProfile: profile }),
  setBrandRFMProfileId: (id) => set({ brandRFMProfileId: id }),
  setBrandRFMProfile: (brandRFMProfile) =>
    set((state) => ({
      brandRFMProfile,
    })),
}));
